
import { AssetTypeTypeInfoBase } from './asset-type.typeinfo.base';


export class AssetTypeTypeInfo extends AssetTypeTypeInfoBase {
}

export const ASSET_TYPE_TYPE: AssetTypeTypeInfo = new AssetTypeTypeInfo();



